import { SavedCruiseCabinsNotificationData } from "@cruisen/contract"
import { _t } from "@cruisen/i18n"
import { observer } from "mobx-react-lite"
import styles from "./SavedCruiseCabins.module.scss"
import UserAvatar from "../../../atoms/UserAvatar"
import { NavigatorCruiseCard } from "../../../cards/NavigatorCruiseCard"
import { getAuth } from "firebase/auth"

export const SavedCruiseCabins = observer(
  ({ data, messageId }: { data: SavedCruiseCabinsNotificationData; messageId: string }) => {
    const currentUser = getAuth().currentUser

    const authorName =
      currentUser.uid === data.userId
        ? _t("common.you")
        : `${data.userFirstName} ${data.userLastNameInitial}.`

    console.log(JSON.stringify(data, null, 2))
    return (
      <>
        <div className={styles.header}>
          <UserAvatar
            nameInitals={`${data.userFirstName[0]}${data.userLastNameInitial}`}
            avatar={data.userAvatar}
            size={"sm"}
            fontSize={"14px"}
          />
          <p
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html:
                data.savedCabins.length === 1
                  ? `${authorName} selected Cabin ${data.savedCabins[0].cabinNo} for ${data.savedCabins[0].roomName}`
                  : `${authorName} selected ${data.savedCabins.length} cabins: ${data.savedCabins
                      .map((cabin) => `<br />Cabin ${cabin.cabinNo} for ${cabin.roomName}`)
                      .join("")}`,
            }}
          />
        </div>
        <NavigatorCruiseCard data={data} testID={messageId} />
      </>
    )
  },
)
